// GridDiscoverUsers.js
'use strict';
import { connect } from 'react-redux';

import GridDiscoverUsers from '../component/GridDiscoverUsers.jsx';

import sendChatStart from '../action/sendChatStart.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { SEARCH_SWAGGER_ONLINE_FEED } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { category: categoryArg }) => {
  const searchSwaggerOnlineFeed = getRemoteConfigData(
    state,
    SEARCH_SWAGGER_ONLINE_FEED
  );
  const category = categoryArg || searchSwaggerOnlineFeed;
  const selectPath = ['home', 'users', category];
  const userIds = getListData(state, selectPath, 'itemIds');
  const nextPage = getListData(state, selectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    [...selectPath, nextPage],
    'isFetching'
  );

  return {
    category,
    userIds,
    isAuthed: !!getMeData(state, 'id'),
    isNextPageFetching,
    nextPage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: ({ type, page, limit, httpProxyHeaders }) =>
      dispatch(fetchFeeds({ type, page, limit, httpProxyHeaders })),
    sendChatStart: ({ userId }) => dispatch(sendChatStart({ userId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GridDiscoverUsers);
